/**
 * AI画像生成 共通型定義
 */

export enum GenerationStatus {
  IDLE = "idle",
  GENERATING = "generating",
  COMPLETE = "complete",
  ERROR = "error",
}

export interface AIGenerateOptions {
  gender?: "male" | "female" | "none" | "prefer_not_to_say";
  age?: number;
  // 子ども用フィールド
  favorite_colors?: string[];
  self_introduction?: string;
  best_subjects?: string[];
  // 容姿フィールド
  glasses?: string;
  accessory?: string[];
  hairstyle?: string;
  body_type?: string;
  face_shape?: string;
  // 保護者用フィールド
  occupation?: string;
  job_title?: string;
  organization?: string;
  industry?: string;
  annual_income?: string;
  region?: string;
  city?: string;
  user_role?: string;
  household_members?: string[];
  boys_count?: number;
  girls_count?: number;
  // 追加プロンプト（再生成時のユーザー入力）
  additional_prompt?: string;
}

export interface AIImageResult {
  id: number;
  url: string;
  fileSize: number;
}

export interface AIImageUsageInfo {
  used: number;
  remaining: number;
  limit: number;
  unlimited: boolean;
}

export interface AIGeneratedAsset {
  id: number;
  uid: string;
  type: string;
  name: string;
  tags: string;
  content_type: string;
  file_size: number;
  metadata: { width: string; height: string };
  url: string;
  created_at: string;
}

export interface ImageGenerationSSECallbacks {
  onStart: (requestId: string) => void;
  onPartialImage: (b64Json: string, progress: number, index: number, imageIndex?: number) => void;
  onComplete: (imageUrl: string, id: number, fileSize: number, imageIndex?: number) => void;
  onAllComplete?: (assets: AIGeneratedAsset[], usage?: AIImageUsageInfo) => void;
  onError: (code: string, message: string) => void;
}

export type ImagePurpose = "child_profile_icon" | "parent_profile_icon";

export interface GenerateImageParams {
  uid?: string;
  options: AIGenerateOptions;
  purpose?: ImagePurpose;
  callbacks: ImageGenerationSSECallbacks;
  signal?: AbortSignal;
}
